import { useAuth } from '@app/api/auth/useAuth';
import { useDialogContext } from '@app/components/dialogs/DialogProvider';
import { ThemeButtonIcon } from '@shared/ui/buttons';

export default function LogoutBtn() {
  const { logoutUser } = useAuth();
  const { closeModal } = useDialogContext();

  async function handleLogout() {
    await logoutUser();
    closeModal();
  }

  return <ThemeButtonIcon icon="logout" onClick={handleLogout} />;
}
